var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGameIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2 4C4.95 4 2.193 6.196 1.733 9.151l-.71 4.573C.834 14.925 1.85 16 3.171 16c.762 0 1.469-.367 1.861-.968L7.3 11.714h5.4l2.267 3.318c.392.6 1.099.968 1.861.968 1.322 0 2.337-1.075 2.15-2.276l-.711-4.573C17.807 6.196 15.05 4 11.8 4H8.2zM7 6L5 8l2 2 2-2-2-2zm7 0a1 1 0 11-2 0 1 1 0 012 0zm-2.75 3a1 1 0 100-2 1 1 0 000 2zm.75 1a1 1 0 112 0 1 1 0 01-2 0zm2.75-3a1 1 0 100 2 1 1 0 000-2z",
    fill: "#9A9CAC"
  })));
}

export default SvgGameIcon;